import { User as UserDto } from "../../../common/model/user";

export default class User {
  constructor(public id: string, public name: string, public email: string = "", public userName: string = "") {}

  static fromDto(u: UserDto): User {
    return new User(u.userId, u.displayName, u.email, u.userName);
  }
}
